// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__23BDS","messages":"Chat_messages__2J8NO","dateDivider":"Chat_dateDivider__r_uDq"};